import { apiClient } from "./client";
import type {
  DashboardSummaryResponse,
  DashboardDetailsResponse,
} from "../types/dashboard";

/**
 * Fetches the dashboard summary data for the given years and class filter.
 */
export async function fetchSummary(
  years: number[],
  classFilter: string
): Promise<DashboardSummaryResponse> {
  const params = new URLSearchParams();
  years.forEach((y) => params.append("years", String(y)));
  params.set("class_filter", classFilter);

  const response = await apiClient.get<DashboardSummaryResponse>(
    "/api/dashboard/summary",
    { params }
  );
  return response.data;
}

/**
 * Fetches transaction-level detail data for a specific year/quarter/class drill-down.
 */
export async function fetchDetails(
  year: number,
  quarter: number,
  className: string
): Promise<DashboardDetailsResponse> {
  const response = await apiClient.get<DashboardDetailsResponse>(
    "/api/dashboard/details",
    {
      params: {
        year,
        quarter,
        class_name: className,
      },
    }
  );
  return response.data;
}

/**
 * Fetches the list of available QuickBooks class names for filtering.
 */
export async function fetchClasses(): Promise<string[]> {
  const response = await apiClient.get<string[]>("/api/dashboard/classes");
  return response.data;
}

/**
 * Triggers a full data refresh from QuickBooks on the backend.
 */
export async function refreshData(): Promise<void> {
  await apiClient.post("/api/dashboard/refresh");
}
